// /* eslint no-param-reassign: "error" */
//
import helper from './helper'

export default {
  updateAssetIdForAssetComponents(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      for (let j = 0; j < payload.assetComponentsForCurrentAsset.length; j++) {
        if (state.assetComponents[i] === payload.assetComponentsForCurrentAsset[j]) {
          state.assetComponents[i].assetId = payload.newAssetId;
        }
      }
    }
    for (let i = 0; i < state.assetComponents.length; i++) {
      state.assetComponents[i].validationIndex = i;
    }
  },
  deleteAsset(state, payload) {
    let newAssetComponents = state.assetComponents.filter(item => item.assetId !== payload.assetId);

    state.assetComponents = [];
    state.assetComponents = newAssetComponents;
    for (let i = 0; i < state.assetComponents.length; i++) {
      state.assetComponents[i].validationIndex = i;
    }

    for (let i = 0; i < state.assetComponents.length; i++) {
      for (let q = 0; q < state.assetComponents[i].lessorComponentShares.length; q++) {
        for (let j = 0; j < state.assetComponents[i].lessorComponentShares[q].paymentsParameters.length; j++) {
          state.assetComponents[i].lessorComponentShares[q].paymentsParameters[j].validationIndex = j;
        }
      }
    }
  },
  setNewAssetComponent(state, assetComponent) {
    state.assetComponents.push(assetComponent);
    for (let i = 0; i < state.assetComponents.length; i++) {
      state.assetComponents[i].validationIndex = i;
    }
  },
  updateAssetComponent(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i] === payload.assetComponent) {
        state.assetComponents[i][payload.name] = payload.value;
      }
    }
    for (let i = 0; i < state.assetComponents.length; i++) {
      state.assetComponents[i].validationIndex = i;
    }
  },
  addAssetComponentNewDevaluation(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i] === payload.assetComponent) {
        state.assetComponents[i].devaluations.push(payload.devaluationsItem);
      }
    }
  },
  updateAssetComponentDevaluation(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i] === payload.assetComponent) {
        for (let j = 0; j < state.assetComponents[i].devaluations.length; j++) {
          if (state.assetComponents[i].devaluations[j] === payload.devaluationsItem) {
            state.assetComponents[i].devaluations[j] = payload.devaluationsItem;
          }
        }
      }
    }
  },
  removeAssetComponentDevaluation(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i] === payload.assetComponent) {
        for (let j = 0; j < state.assetComponents[i].devaluations.length; j++) {
          if (state.assetComponents[i].devaluations[j] === payload.devaluationsItem) {
            state.assetComponents[i].devaluations.splice(j, 1);
          }
        }
      }
    }
  },
  addAssetComponentNewExpenses(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i] === payload.assetComponent) {
        state.assetComponents[i].expenses.push(payload.expensesItem);
      }
    }
  },
  updateAssetComponentExpenses(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i] === payload.assetComponent) {
        for (let j = 0; j < state.assetComponents[i].expenses.length; j++) {
          if (state.assetComponents[i].expenses[j] === payload.expensesItem) {
            state.assetComponents[i].expenses[j] = payload.expensesItem;
          }
        }
      }
    }
  },
  removeAssetComponentExpenses(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i] === payload.assetComponent) {
        for (let j = 0; j < state.assetComponents[i].expenses.length; j++) {
          if (state.assetComponents[i].expenses[j] === payload.expensesItem) {
            state.assetComponents[i].expenses.splice(j, 1);
          }
        }
      }
    }
  },
  deleteAssetComponent(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i] === payload.assetComponent) {
        state.assetComponents.splice(i, 1);
      }
    }
    for (let i = 0; i < state.assetComponents.length; i++) {
      state.assetComponents[i].validationIndex = i;
    }

    for (let i = 0; i < state.assetComponents.length; i++) {
      for (let q = 0; q < state.assetComponents[i].lessorComponentShares.length; q++) {
        for (let j = 0; j < state.assetComponents[i].lessorComponentShares[q].paymentsParameters.length; j++) {
          state.assetComponents[i].lessorComponentShares[q].paymentsParameters[j].validationIndex = j;
        }
      }
    }
  },
  removeAssetComponents(state, assetId) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i].assetId === assetId) {
        state.assetComponents.splice(i, 1);
      }
    }
    for (let i = 0; i < state.assetComponents.length; i++) {
      state.assetComponents[i].validationIndex = i;
    }

    for (let i = 0; i < state.assetComponents.length; i++) {
      for (let q = 0; q < state.assetComponents[i].lessorComponentShares.length; q++) {
        for (let j = 0; j < state.assetComponents[i].lessorComponentShares[q].paymentsParameters.length; j++) {
          state.assetComponents[i].lessorComponentShares[q].paymentsParameters[j].validationIndex = j;
        }
      }
    }
  },
  addTerminationOption(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i].assetId === payload.assetId && state.assetComponents[i] === payload.assetComponent) {
        state.assetComponents[i].termination = payload.data;
      }
    }
  },
  addExtensionOption(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i].assetId === payload.assetId && state.assetComponents[i] === payload.assetComponent) {
        state.assetComponents[i].extension = payload.data;
      }
    }
  },
  addBuyoutOption(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i].assetId === payload.assetId && state.assetComponents[i] === payload.assetComponent) {
        state.assetComponents[i].buyout = payload.data;
      }
    }
  },
  updateTerminationOption(state, termination) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i].assetId === termination.assetId && state.assetComponents[i] === termination.assetComponent) {
        state.assetComponents[i].termination[termination.name] = termination.value;
      }
    }
  },
  updateExtensionOption(state, extension) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i].assetId === extension.assetId && state.assetComponents[i] === extension.assetComponent) {
        state.assetComponents[i].extension[extension.name] = extension.value;
      }
    }
  },
  updateBuyoutOption(state, buyout) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      if (state.assetComponents[i].assetId === buyout.assetId && state.assetComponents[i] === buyout.assetComponent) {
        state.assetComponents[i].buyout[buyout.name] = buyout.value;
      }
    }
  },
  setNewPayment(state, data) {
    state.assetComponents[data.index].lessorComponentShares[data.lessorIndex].paymentsParameters.push(data.payment);

    for (let i = 0; i < state.assetComponents.length; i++) {
      for (let q = 0; q < state.assetComponents[i].lessorComponentShares.length; q++) {
        for (let j = 0; j < state.assetComponents[i].lessorComponentShares[q].paymentsParameters.length; j++) {
          state.assetComponents[i].lessorComponentShares[q].paymentsParameters[j].validationIndex = j;
        }
      }
    }
  },
  setNewLessorComponentShares(state, data) {
    state.assetComponents[data.index].lessorComponentShares.push(data.lessor);
  },
  updatePayment(state, payload) {
    payload.payment[payload.name] = payload.value
  },
  updatePaymentByIdInDb(state, payload) {
    const paymentToUpdate = helper.findPaymentByIdInDb(state, payload.paymentIdInDb)
    paymentToUpdate.paymentNameId = payload.value
  },
  deletePayment(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      for (let q = 0; q < state.assetComponents[i].lessorComponentShares.length; q++) {
        for (let j = 0; j < state.assetComponents[i].lessorComponentShares[q].paymentsParameters.length; j++) {
          if (state.assetComponents[i].lessorComponentShares[q].paymentsParameters[j] === payload.payment) {
            state.assetComponents[i].lessorComponentShares[q].paymentsParameters.splice(j, 1);
          }
        }
      }
    }

    for (let i = 0; i < state.assetComponents.length; i++) {
      for (let q = 0; q < state.assetComponents[i].lessorComponentShares.length; q++) {
        for (let j = 0; j < state.assetComponents[i].lessorComponentShares[q].paymentsParameters.length; j++) {
          state.assetComponents[i].lessorComponentShares[q].paymentsParameters[j].validationIndex = j;
        }
      }
    }
  },
  updatePaymentCurrencyRateParams(state, payload) {
    payload.payment.currencyRateParameters[payload.name] = payload.value
  },

  updatePaymentIncrementPercents(state, payload) {
    payload.payment.currencyRateIncreasePercents = payload.value
  },

  updatePaymentIndexation(state, payload) {
    payload.payment.indexation[payload.name] = payload.value
  },

  updatePaymentDiscount(state, payload) {
    payload.payment.discount[payload.name] = payload.value
  },

  updatePaymentDiscountByPaymentId(state, payload) {
    const paymentToUpdate = helper.findPaymentByIdInDb(state, payload.id)
    paymentToUpdate.discount.discountRate = payload.value;
  },

  updateLessorComponentShare(state, payload) {
    for (let i = 0; i < state.assetComponents.length; i++) {
      for (let j = 0; j < state.assetComponents[i].lessorComponentShares.length; j++) {
        if (state.assetComponents[i].lessorComponentShares[j] === payload.lessor) {
          state.assetComponents[i].lessorComponentShares[j][payload.name] = payload.value;
        }
      }
    }
  },
};
